import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../components/global/Button';
import { formatPhone } from '../../../../../util/phone';
import PinField from '../../../../../components/global/PinField';
import CustomControl from '../../../../../components/global/CustomControl';

const propTypes = {
  values: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
    phone_number: PropTypes.string,
    code: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  onPinCodeResend: PropTypes.func.isRequired,
  requireHumanInput: PropTypes.bool,
  blockLogin: PropTypes.bool,
};

const PinVerifyForm = ({
  values,
  loading,
  handleSubmit,
  handleChange,
  onPinCodeResend,
  requireHumanInput,
  blockLogin,
}) => {
  const isValid = values.code?.length === 4;

  // Reset handle action in case we need this input again
  useEffect(() => {
    handleChange({
      target: {
        name: 'force_allow_action',
        value: false,
      },
    });
  }, []);

  return (
    <Fragment>
      <h4 className="text-center">
        Please enter the code that was sent to <br />
        <span className="text-primary">{formatPhone(values.phone_number)}</span>
        .
      </h4>
      <form
        onSubmit={handleSubmit}
        className="d-flex flex-column align-items-center"
      >
        <div className="mb-2">
          <PinField
            onComplete={value => {
              handleChange({
                target: {
                  name: 'code',
                  value,
                },
              });
            }}
            onChange={value => {
              handleChange({
                target: {
                  name: 'code',
                  value,
                },
              });
            }}
          />
        </div>

        <Button type="submit" btnBlock disabled={loading || !isValid}>
          {loading ? 'Processing...' : 'Submit'}
        </Button>

        {requireHumanInput && (
          <div className="w-100 text-center mt-2">
            <CustomControl
              type="checkbox"
              label="I'm not a robot"
              checked={values.force_allow_action}
              onChange={() =>
                handleChange({
                  target: {
                    name: 'force_allow_action',
                    value: !values.force_allow_action,
                  },
                })
              }
            />
          </div>
        )}

        <Button
          type="button"
          btnStyle="link"
          disabled={
            loading ||
            blockLogin ||
            (requireHumanInput && !values.force_allow_action)
          }
          loading={loading}
          className="text-extra-bold mt-2"
          onClick={() => onPinCodeResend(values)}
        >
          Re&ndash;send code
        </Button>
      </form>
    </Fragment>
  );
};

PinVerifyForm.propTypes = propTypes;

export default PinVerifyForm;
